import { render } from "./BetSlipMain.vue?vue&type=template&id=353cd243&scoped=true"
import script from "./BetSlipMain.vue?vue&type=script&lang=js"
export * from "./BetSlipMain.vue?vue&type=script&lang=js"

import "./BetSlipMain.vue?vue&type=style&index=0&id=353cd243&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353cd243"]])

export default __exports__